import { AppBar, IconButton } from "@mui/material";
import { useState } from "react";
import classNames from "../../utilities/classNames";
import "./HomepageNavbar.scss";
import MobileNavDrawer from "./MobileNavDrawer";
import { loginItems, navbarItems, socialItems } from "./navbar-items.js";

const HomepageNavbar = ({ transparentNavbar = true }) => {
  const [isTransparent, setIsTransparent] = useState(transparentNavbar);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleTransparency = () => {
    if (window.scrollY >= 500) {
      setIsTransparent(false);
    } else {
      setIsTransparent(true);
    }
  };

  transparentNavbar && window.addEventListener("scroll", handleTransparency);

  return (
    <AppBar {...classNames("homepage-navbar", !isTransparent && "solid-nav")}>
      <div className="flex">
        {loginItems}
        <div className="nav-link-container">
          {navbarItems}
          <div className="nav-social-links-container">{socialItems}</div>
        </div>
        <div className="nav-drawer-toggle">
          <IconButton
            size="medium"
            className="nav-drawer-toggle-button"
            onClick={() => setIsDrawerOpen(true)}
          >
            <i className="fa-solid fa-bars"></i>
          </IconButton>
          <MobileNavDrawer
            isDrawerOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
          />
        </div>
      </div>
    </AppBar>
  );
};

export default HomepageNavbar;
